import { c as _c } from "react/compiler-runtime";
import { Divider, Stack, Typography } from '@mui/material';
import { HelpIcon } from './helpIcon';
import { CopyToClipboardButton } from '../buttons/copyToClipboardButton';
export function CopyableCode(t0) {
  const $ = _c(49);
  const {
    title,
    code,
    codeClassName,
    variant,
    tooltipTitle,
    maxHeight,
    blur: t1
  } = t0;
  const blur = t1 === undefined ? false : t1;
  const color = variant === "error" ? "var(--mui-palette-error-main)" : "var(--mui-palette-text-primary)";
  const bgColorClass = variant === "error" ? "bg-(--mui-palette-error-opacity)" : "bg-(--mui-palette-background-secondary)";
  if (title) {
    const t2 = `w-full p-[16px] ${bgColorClass} rounded-[4px]`;
    let t3;
    if ($[0] !== color) {
      t3 = <Divider sx={{
        borderStyle: "dashed",
        borderColor: color
      }} />;
      $[0] = color;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    let t4;
    if ($[2] !== maxHeight) {
      t4 = {
        gap: "12px",
        maxHeight
      };
      $[2] = maxHeight;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = {
        gap: "8px",
        alignItems: "center",
        justifyContent: "space-between"
      };
      $[4] = t5;
    } else {
      t5 = $[4];
    }
    let t6;
    if ($[5] !== color) {
      t6 = {
        color
      };
      $[5] = color;
      $[6] = t6;
    } else {
      t6 = $[6];
    }
    let t7;
    if ($[7] !== t6 || $[8] !== title) {
      t7 = <Typography variant="subtitle1Strong" sx={t6}>{title}</Typography>;
      $[7] = t6;
      $[8] = title;
      $[9] = t7;
    } else {
      t7 = $[9];
    }
    let t8;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = {
        gap: "8px",
        alignItems: "center"
      };
      $[10] = t8;
    } else {
      t8 = $[10];
    }
    let t9;
    if ($[11] !== tooltipTitle) {
      t9 = tooltipTitle && <HelpIcon alwaysVisible={true} title={tooltipTitle} className="text-xl" tooltipProps={{
        disableInteractive: false
      }} />;
      $[11] = tooltipTitle;
      $[12] = t9;
    } else {
      t9 = $[12];
    }
    const t10 = blur ? "" : code;
    const t11 = blur ? "Fill all required fields before copy" : undefined;
    const t12 = `text-[${color}]`;
    let t13;
    if ($[13] !== t10 || $[14] !== t11 || $[15] !== t12) {
      t13 = <CopyToClipboardButton textToCopy={t10} disabledTooltip={t11} className={t12} />;
      $[13] = t10;
      $[14] = t11;
      $[15] = t12;
      $[16] = t13;
    } else {
      t13 = $[16];
    }
    let t14;
    if ($[17] !== t13 || $[18] !== t9) {
      t14 = <Stack direction="row" sx={t8}>{t9}{t13}</Stack>;
      $[17] = t13;
      $[18] = t9;
      $[19] = t14;
    } else {
      t14 = $[19];
    }
    let t15;
    if ($[20] !== t14 || $[21] !== t7) {
      t15 = <Stack direction="row" sx={t5}>{t7}{t14}</Stack>;
      $[20] = t14;
      $[21] = t7;
      $[22] = t15;
    } else {
      t15 = $[22];
    }
    let t16;
    if ($[23] !== blur || $[24] !== code || $[25] !== codeClassName || $[26] !== color) {
      t16 = <CodeBlock code={code} className={codeClassName} color={color} blur={blur} />;
      $[23] = blur;
      $[24] = code;
      $[25] = codeClassName;
      $[26] = color;
      $[27] = t16;
    } else {
      t16 = $[27];
    }
    let t17;
    if ($[28] !== t15 || $[29] !== t16 || $[30] !== t2 || $[31] !== t3 || $[32] !== t4) {
      t17 = <Stack className={t2} divider={t3} sx={t4}>{t15}{t16}</Stack>;
      $[28] = t15;
      $[29] = t16;
      $[30] = t2;
      $[31] = t3;
      $[32] = t4;
      $[33] = t17;
    } else {
      t17 = $[33];
    }
    return t17;
  }
  const t2 = `w-full p-[16px] ${bgColorClass} rounded-[4px]`;
  let t3;
  if ($[34] !== maxHeight) {
    t3 = {
      gap: "8px",
      alignItems: "start",
      maxHeight
    };
    $[34] = maxHeight;
    $[35] = t3;
  } else {
    t3 = $[35];
  }
  let t4;
  if ($[36] !== blur || $[37] !== code || $[38] !== codeClassName || $[39] !== color) {
    t4 = <CodeBlock code={code} className={codeClassName} color={color} blur={blur} />;
    $[36] = blur;
    $[37] = code;
    $[38] = codeClassName;
    $[39] = color;
    $[40] = t4;
  } else {
    t4 = $[40];
  }
  const t5 = blur ? "" : code;
  const t6 = `text-[${color}]`;
  let t7;
  if ($[41] !== t5 || $[42] !== t6) {
    t7 = <CopyToClipboardButton textToCopy={t5} className={t6} />;
    $[41] = t5;
    $[42] = t6;
    $[43] = t7;
  } else {
    t7 = $[43];
  }
  let t8;
  if ($[44] !== t2 || $[45] !== t3 || $[46] !== t4 || $[47] !== t7) {
    t8 = <Stack direction="row" className={t2} sx={t3}>{t4}{t7}</Stack>;
    $[44] = t2;
    $[45] = t3;
    $[46] = t4;
    $[47] = t7;
    $[48] = t8;
  } else {
    t8 = $[48];
  }
  return t8;
}
const CodeBlock = t0 => {
  const $ = _c(6);
  const {
    code,
    className,
    color,
    blur: t1
  } = t0;
  const blur = t1 === undefined ? false : t1;
  const t2 = ` break-pretty w-full whitespace-pre overflow-x-auto text-[13px] text-[${color}] ${className ?? ""}`;
  let t3;
  if ($[0] !== blur || $[1] !== code) {
    t3 = blur ? <span className="select-none pointer-events-none" style={{
      userSelect: "none",
      color: "var(--mui-palette-text-disabled)"
    }}>{code}</span> : code;
    $[0] = blur;
    $[1] = code;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = <code className={t2}>{t3}</code>;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};